import { ReactNode, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

interface Props {
    title: string;
    message: string;
    children: (callbackFunc: (callbackFunc: Function) => (event: any) => void) => ReactNode;
}

export function ConfirmDialog(props: Props) {
    const [open, setOpen] = useState(false);
    const [callback, setCallback] = useState<() => void>();

    const show = (callbackFunc: Function) => (event: any) => {
        if (event.preventDefault) {
            event.preventDefault();
        }

        const callbackValue = () => () => {
            callbackFunc(event);
        };
        setOpen(true);
        setCallback(callbackValue);
    };

    const handleAgree = () => {
        callback?.();
        handleClose();
    };

    const handleClose = () => {
        setOpen(false);
        setCallback(undefined);
    };

    return (
        <>
            {props.children(show)}
            <Dialog open={open} onClose={handleClose} aria-labelledby="confirm-dialog-title" aria-describedby="confirm-dialog-description">
                <DialogTitle id="confirm-dialog-title">{props.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="confirm-dialog-description">{props.message}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleAgree} autoFocus>
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
